import { render, staticRenderFns } from "./PostoColetaComponente.vue?vue&type=template&id=4695d27a&scoped=true"
import script from "./PostoColetaComponente.vue?vue&type=script&lang=js"
export * from "./PostoColetaComponente.vue?vue&type=script&lang=js"
import style0 from "./PostoColetaComponente.vue?vue&type=style&index=0&id=4695d27a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4695d27a",
  null
  
)

export default component.exports